import { Button, Modal } from "@/components/common";

interface ResetCommissionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  defaultRate: number;
  customCount: number;
  isLoading?: boolean;
}

export function ResetCommissionsModal({
  isOpen,
  onClose,
  onConfirm,
  defaultRate,
  customCount,
  isLoading = false,
}: ResetCommissionsModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Resetuj prowizje">
      <div className="space-y-4">
        <p className="text-sm text-sub">
          Czy na pewno chcesz zresetować prowizje wszystkich agentów?
        </p>
        <p className="text-sm text-sub">
          Ustawisz{" "}
          <span className="font-semibold text-main">{defaultRate}%</span>{" "}
          (domyślna) dla{" "}
          <span className="font-semibold text-main">{customCount}</span> agentów
          z niestandardową prowizją.
        </p>

        <div className="flex justify-end gap-3 pt-2">
          <Button variant="outline" onClick={onClose}>
            Anuluj
          </Button>
          <Button variant="danger" onClick={onConfirm} isLoading={isLoading}>
            Resetuj wszystkie
          </Button>
        </div>
      </div>
    </Modal>
  );
}
